import React from 'react'
import Box from '@material-ui/core/Box'
import MuiDialogActions from '@material-ui/core/DialogActions'
import MuiDialogContent from '@material-ui/core/DialogContent'
import Slide, { SlideProps } from '@material-ui/core/Slide'
import Stepper from '@material-ui/core/Stepper'
import Typography from '@material-ui/core/Typography'
import styled from 'styled-components'
import { Layouts } from '../../../consts'
import { customTheme } from '../../../libraries/MaterialUI'

export const stepperHeight = '40px'

export const SubmitModalStepper = styled(Stepper)`
  padding: ${customTheme.spacing(1, 1)};
  margin: ${customTheme.spacing(1, 0, 2, 0)};
  height: ${stepperHeight};
`

export const SubmitModalDialogContent = styled(MuiDialogContent)`
  width: 100%;
  padding: ${customTheme.spacing(0, 0)};
`

export const SubmitModalDialogContentInner = styled(Box)`
  margin: 0 auto;
  max-width: ${Layouts.MaxMainContentWidth};
  min-width: ${Layouts.MinMainContentWidth};
`

export const SubmitModalDialogActions = styled(MuiDialogActions)`
  margin: 0;
  padding: ${customTheme.spacing(1, 1)};
`

export const MainContent = styled(Box)`
  height: calc(100% - ${stepperHeight});
`

export const Transition = React.forwardRef<unknown, Omit<SlideProps, 'direction'>>((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Slide direction="up" ref={ref} {...props} />
))

export const SupplementBox: React.FC = ({ children }) => (
  <Box paddingTop={1} paddingLeft={2}>
    <Typography variant="body2" color="primary">
      {children}
    </Typography>
  </Box>
)
